import React from "react"
import type { ReactNode, CSSProperties } from "react"

type Spacing = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 16

const GAP: Record<Spacing, string> = {
  0: "gap-0",
  1: "gap-1",
  2: "gap-2",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  8: "gap-8",
  10: "gap-10",
  16: "gap-16"
}

export type StackProps = {
  /** Vertical gap between children (one of: 0, 1, 2, 3, 4, 5, 6, 8, 10, 16) */
  spacing?: Spacing
  /** Content to stack vertically */
  children: ReactNode
  /** Additional CSS classes */
  className?: string
  /** HTML id attribute */
  id?: string
  /** Inline styles */
  style?: CSSProperties
}

/**
 * Arranges children in a vertical flex column with consistent spacing.
 * Uses Tailwind gap utilities for the spacing between items.
 */
function Stack({
  spacing = 0,
  children,
  className = "",
  id,
  style
}: StackProps) {
  const gapClassName = GAP[spacing]
  return (
    <div
      id={id}
      style={style}
      className={`flex flex-col ${gapClassName} ${className}`.trim()}
    >
      {children}
    </div>
  )
}

export { Stack }
export default Stack
